import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from '@hello-pangea/dnd';
import CustomFieldContent from './CustomFieldContent';

const CustomFieldItem = ({
  field,
  getIconClass,
  handleEditClick,
  setSelectedDate,
  numberValue,
  setNumberValue,
  isDraggable = true,
  isDragDisabled = false,
  draggableIndex,
}) => {
  const content = (
    <CustomFieldContent
      field={field}
      getIconClass={getIconClass}
      handleEditClick={handleEditClick}
      setSelectedDate={setSelectedDate}
      numberValue={numberValue}
      setNumberValue={setNumberValue}
    />
  );

  if (!isDraggable) return content;

  return (
    <Draggable
      draggableId={String(field.id)}
      index={draggableIndex}
      isDragDisabled={isDragDisabled}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className="w-full"
          style={{
            ...provided.draggableProps.style,
            opacity: snapshot.isDragging ? 0.5 : 1,
          }}
        >
          {content}
        </div>
      )}
    </Draggable>
  );
};

CustomFieldItem.propTypes = {
  field: PropTypes.object.isRequired,
  getIconClass: PropTypes.func.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  numberValue: PropTypes.object.isRequired,
  setNumberValue: PropTypes.func.isRequired,
  draggableIndex: PropTypes.number.isRequired,
  isDraggable: PropTypes.bool,
  isDragDisabled: PropTypes.bool,
};

export default CustomFieldItem;
